import kr from './kr.js';
import en from './en.js';
import jp from './jp.js';

export default { kr, en, jp };
